import {useRouter} from "next/router";
import localized from "../../locale/locales";
import Container from "../Container";
import TrainerCard from "../TrainerCard";

import {useEffect, useState} from "react";
import Title from "../Title";
import Typo from "../Typo";
import Select from "../Select";
import {getTrainers, trainersConcepts, trainersList} from "../../helpers/trainers";
import SvgChevronDown from "../../svg/SvgChevronDown";
import {locationsEnum} from "../../helpers/locations";


function Filters({activeFilters, setActiveFilters}) {
    const {locale} = useRouter();
    const lang = localized[locale].personalTraining.trainers;

    const filters = {
        ...lang.filters,
        concept: trainersConcepts,
        location: locationsEnum
    }

    return (
        <div>
            <Container className="pt-20 pb-40 md:pb-48 text-center flex flex-col items-center gap-8">
                <header>
                    <Title>
                        {lang.title}
                    </Title>
                </header>
                <div className="flex flex-wrap gap-6 justify-center">
                    {Object.keys(filters).filter(i => i !== 'labels').map((filterLabel, filterGroupIndex) => {
                        const label = lang.filters.labels[filterLabel];
                        const optionsObject = filters[filterLabel];
                        const options = Object.keys(optionsObject).map((key) => ({
                            value: key,
                            label: optionsObject[key]
                        }));

                        return (
                            <Select
                                key={`Filter: ${filterGroupIndex}`}
                                label={label}
                                onChange={(filterName) => {
                                    setActiveFilters({
                                        ...activeFilters,
                                        [filterLabel]: filterName
                                    })
                                }}
                                options={options}
                                className="z-20"
                                selected={activeFilters[filterLabel]}
                                onClear={() => setActiveFilters({...activeFilters, [filterLabel]: null})}
                            />
                        )
                    })}
                </div>
            </Container>
        </div>
    )
}

const defaultFilters = {
    gender: null,
    concept: null,
    location: null
};

export default function SectionTrainers({showFilters = false, location = null, limit = 9999}) {
    const {locale} = useRouter();
    const lang = localized[locale].personalTraining.trainers;
    const {common} = localized[locale];

    const [activeCard, setActiveCard] = useState(null);
    const [activeFilters, setActiveFilters] = useState(defaultFilters);
    const [activeTrainers, setActiveTrainers] = useState(getTrainers(trainersList, activeFilters, location));

    const [trainersCount, setTrainersCount] = useState(0);
    const [isTrainersOpen, setIsTrainersOpen] = useState(false);

    const resetFilters = () => {
        setActiveFilters(defaultFilters);
    }

    useEffect(() => {
        setActiveTrainers(getTrainers(trainersList, activeFilters, location));
    }, [activeFilters, location]);

    useEffect(() => {
        setTrainersCount(activeTrainers.length);
    }, [activeTrainers]);

    return (
        <>
            {showFilters && (
                <Filters activeFilters={activeFilters}
                         setActiveFilters={setActiveFilters}
                         resetFilters={resetFilters}
                />
            )}

            {activeTrainers.length === 0 && (
                <Container className="text-center">
                    <Typo className="md:text-xl">{lang.noResults}</Typo>
                </Container>
            )}

            {activeTrainers.length > 0 && (
                <div className="flex flex-col">
                    <div className="bg-black relative z-10">
                        <Container className="relative w-full py-px flex flex-col gap-4">
                            <div
                                className={`flex flex-col md:flex-row flex-wrap gap-8 justify-center -mt-16 md:-mt-28 ${trainersCount > limit ? `accordion accordion-concepts accordion-solid accordion-xl overflow-hidden ${isTrainersOpen ? 'accordion-open -mb-16 md:-mb-28' : ''}` : '-mb-16 md:-mb-28'}`}>
                                {activeTrainers.map((trainer, key) => {
                                    return (
                                        <TrainerCard key={`TrainerCard: ${trainer.instagram}`}
                                                     trainer={trainer}
                                                     className="md:max-w-[calc(50%-1rem)] lg:max-w-[calc(33.333%-1.333rem)]"
                                                     active={activeCard === trainer.instagram}
                                                     onMouseEnter={() => setActiveCard(trainer.instagram)}
                                                     onMouseOut={() => setActiveCard(null)}
                                        />
                                    )
                                })}
                            </div>
                        </Container>
                    </div>
                    {trainersCount > limit && (
                        <div
                            className={`relative z-10 flex w-full items-center ${isTrainersOpen ? 'mt-16 md:mt-28' : ''}`}>
                            <button
                                onClick={() => setIsTrainersOpen(!isTrainersOpen)}
                                className="mx-auto flex gap-2 items-center pt-6 text-xs uppercase text-black border-b border-black mouse-hover:border-transparent transition-colors duration-200"
                            >
                                {isTrainersOpen ? common.showLessTrainers : common.showAllTrainers}
                                <SvgChevronDown width={7}
                                                className={`transform transition-transform ${isTrainersOpen ? 'rotate-180' : ''}`}
                                />
                            </button>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}
